const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const AT = require("../core/vault/ActionTypes");
const OpsSchool = require("./vault/OpsSchool");
const Link = require("../core/view/Link");
const URLMake = require("../../shared/URLMake");
const Editable = require("../office/Editable");
const SortableTable = require("./SortableTable");
const CopyTable = require("./data/CopyTable");
const HoverText = require("../core/view/HoverText");
const InfoIcon = require("../office/InfoIcon");

const styles = require("./styles/AccountUser.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "AccountUser",

		propTypes: {
			user: PT.object.isRequired,
			userID: PT.number.isRequired,
			schoolState: PT.object.isRequired,
			showModal: PT.func,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				passwordResetStatus: null,
				passwordResetStatusInfo: null,
			};
		},

		vaultEvents: {
			tempPasswordRequested: function() {
				this.setState({passwordResetStatus: "sent"});
			},
			requestPasswordResetErrors: function(error, info) {
				this.setState({
					passwordResetStatus: error,
					passwordResetStatusInfo: info,
				});
			},
		},

		sortFunctions: {
			name: body => {
				return _.sortBy(body, ["inactive", r => _.toLower(r.nameValue)]);
			},
		},

		widthClasses: {
			name: styles.nameWidth,
			classes: styles.classes,
			teachers: styles.teachers,
			students: styles.students,
			school: styles.school,
			grade: styles.grade,
			remove: styles.removeWidth,
		},

		onResetEmail() {
			const {userID, schoolState} = this.props;
			const teacher = _.get(schoolState, ["accounts", "staff", userID]);
			this.props.dispatch({
				type: AT.PASSWORD_RESET_REQUEST,
				username: teacher.email,
				purchaseID: _.get(schoolState, "accounts.purchase.id"),
			});
		},

		getAuditTable: function(schoolState, userID, isActive, role) {
			return this.getSchoolTable(schoolState, userID, isActive, role, true);
		},

		getSchoolTable: function(schoolState, userID, isActive, role, forAudit) {
			const user = this.props.user;
			const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
			let schools;
			if (forAudit) {
				schools = OpsSchool.getSchoolsForAuditor(schoolState, userID);
			} else {
				schools = OpsSchool.getSchoolsForAdmin(schoolState, userID);
			}
			if (schools.length) {
				const colNames = ["name", "classes", "teachers", "students", "remove"];
				let tableTitle = isActive
					? "Administrator for Schools"
					: "Associated Schools";
				if (forAudit) tableTitle = "Auditor for Schools";
				const headerVals = [
					tableTitle,
					"# Classes",
					"# Teachers",
					"# Students",
					"",
				];
				const viewableSchools = OpsSchool.getViewableSchools(
					schoolState,
					user.userID
				);
				const data = schools.map(s => {
					const allowedRoles = ["purchaseAdmin", "schoolAdmin", "partialAdmin"];
					const schoolPerms = OpsSchool.getBestRoleForSchool(
						schoolState,
						user.userID,
						s.id
					);
					const hasViewPerms = _.includes(
						viewableSchools.map(vs => vs.id),
						s.id
					);
					const hasPerms =
						_.includes(allowedRoles, role) &&
						_.includes(allowedRoles, schoolPerms) &&
						user.userID !== userID;
					const schoolStudents = OpsSchool.getStudentsForSchool(
						schoolState,
						s.id
					);
					const schoolClasses = _.get(schoolState, [
						"accounts",
						"schools",
						s.id,
						"classIDs",
					]);
					const schoolTeachers = OpsSchool.getTeachersForSchool(
						schoolState,
						s.id
					);
					const schoolActive = OpsSchool.isSchoolActive(schoolState, s.id);
					const schoolActiveText = schoolActive ? null : "Inactive";
					return {
						name: hasViewPerms ? (
							<Link to={URLMake.forSchoolAccount(s.id)} className={styles.link}>
								{s.displayName}
							</Link>
						) : (
							s.displayName
						),
						nameValue: s.displayName,
						classes: schoolClasses.length || 0,
						teachers: schoolTeachers.length || 0,
						students: schoolStudents.length || 0,
						remove:
							isActive && s.active && hasPerms && !isAcademy ? (
								<div className={styles.remove}>
									<span
										onClick={() =>
											this.props.showModal("confirmInfo", {
												type: "remove",
												userID,
												schoolID: s.id,
												role: forAudit ? "auditor" : "schoolAdmin",
											})
										}
									>
										Remove from school
									</span>
								</div>
							) : (
								schoolActiveText
							),
						inactive: !schoolActive,
					};
				});
				return (
					<div className={styles.table}>
						<SortableTable
							columnNames={colNames}
							sortableColumns={_.without(colNames, "remove")}
							headers={_.zipObject(colNames, headerVals)}
							initiallySortedBy="name"
							sortFunctions={this.sortFunctions}
							data={data}
							evenRowDark={true}
							headerClasses={{name: styles.name}}
							bodyClasses={{name: styles.row}}
							widthClasses={this.widthClasses}
							canScroll={true}
							grayOutInactive={true}
						/>
					</div>
				);
			} else {
				return null;
			}
		},

		getClassTable: function(schoolState, userID, isActive, role) {
			const user = this.props.user;
			const isStaff = OpsSchool.isStaff(schoolState, userID);
			const purchaseYear = OpsSchool.getPurchaseYear(schoolState);
			const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
			let classes;
			let currClass;
			if (isStaff) {
				classes = OpsSchool.getClassesForTeacher(schoolState, userID, true);
			} else {
				currClass = OpsSchool.getClassForStudent(
					schoolState,
					userID,
					purchaseYear
				);
				classes = OpsSchool.getClassesForStudent(schoolState, userID);
			}
			if (classes.length) {
				let colNames;
				if (isStaff) {
					colNames = ["name", "school", "grade", "students", "remove"];
				} else {
					colNames = ["name", "school", "grade", "year", "enrolled"];
				}
				let headerVals;
				if (isStaff) {
					headerVals = [
						isActive ? "Teacher for Classes" : "Associated Classes",
						"School",
						"Grade",
						"# Students",
						"",
					];
				} else {
					headerVals = ["Classes", "School", "BA Level", "Year", ""];
				}
				const viewableClasses = OpsSchool.getViewableClasses(
					schoolState,
					user.userID
				);
				const data = classes.map(c => {
					const classSchool = OpsSchool.getSchoolForClass(schoolState, c.id);
					const allowedRoles = ["purchaseAdmin", "schoolAdmin", "partialAdmin"];
					const classPerms = OpsSchool.getBestRoleForClass(
						schoolState,
						user.userID,
						c.id
					);
					const hasViewPerms = _.includes(
						viewableClasses.map(vc => vc.id),
						c.id
					);
					const hasPerms =
						_.includes(allowedRoles, role) &&
						_.includes(allowedRoles, classPerms);
					const classStudents = _.get(schoolState, [
						"accounts",
						"classes",
						c.id,
						"studentIDs",
					]);
					const classActive = OpsSchool.isClassActive(schoolState, c.id);
					let classActiveText = classActive ? null : "Inactive";
					if (c.year < purchaseYear) {
						classActiveText = c.year ? c.year - 1 + "-" + c.year : null;
					}
					return {
						name: hasViewPerms ? (
							<Link to={URLMake.forClassAccount(c.id)} className={styles.link}>
								{c.displayName}
							</Link>
						) : (
							c.displayName
						),
						nameValue: c.displayName,
						school: classSchool.displayName,
						grade: c.gradeID,
						students: classStudents.length || 0,
						year: c.year ? c.year - 1 + "-" + c.year : null,
						enrolled:
							!isStaff && currClass && currClass.id === c.id
								? "Enrolled"
								: null,
						remove:
							isActive && classActive && isStaff && hasPerms && !isAcademy ? (
								<div className={styles.remove}>
									<span
										onClick={() =>
											this.props.showModal("confirmInfo", {
												type: "remove",
												userID,
												classID: c.id,
												role: "teacher",
											})
										}
									>
										Remove from class
									</span>
								</div>
							) : (
								classActiveText
							),
						inactive: !classActive,
					};
				});
				return (
					<div className={styles.table}>
						<SortableTable
							columnNames={colNames}
							sortableColumns={_.without(colNames, "remove", "enrolled")}
							headers={_.zipObject(colNames, headerVals)}
							initiallySortedBy="name"
							sortFunctions={this.sortFunctions}
							data={data}
							evenRowDark={true}
							headerClasses={{name: styles.name}}
							bodyClasses={{name: styles.row, enrolled: styles.enrolled}}
							widthClasses={this.widthClasses}
							canScroll={true}
							grayOutInactive={true}
						/>
					</div>
				);
			} else {
				return null;
			}
		},

		renderStaff: function(teacher, role, isAcademy) {
			const {userID, schoolState, showModal} = this.props;
			const {passwordResetStatus, passwordResetStatusInfo} = this.state;
			const isActive = OpsSchool.isStaffResolvedActive(schoolState, teacher.id);

			const hasPassword = teacher.hasPassword;
			const isInitialized = teacher.isInitialized;
			// We need isInitialized === undefined for backwards
			// compatibility for when we haven't started sending this value
			// yet.
			const isAlreadySetUp =
				(isInitialized || isInitialized === undefined) && hasPassword;
			let prClass;
			let prText;

			if (passwordResetStatus === "sent") {
				prClass = styles.prSent;
				prText = isAlreadySetUp
					? "Reset password email sent!"
					: "Setup email sent!";
			} else if (!passwordResetStatus) {
				prClass = styles.passwordReset;
				prText = isAlreadySetUp
					? "Send reset password email"
					: "Resend setup email";
			} else {
				prClass = styles.prError;
				const errorCopy = CopyTable.getPasswordResetErrors(
					passwordResetStatus,
					passwordResetStatusInfo
				);
				prText = errorCopy;
			}
			let paEl;
			if (OpsSchool.isPurchaseAdmin(schoolState, userID)) {
				paEl = (
					<div className={styles.pa}>
						Current System Administrator for{" "}
						{_.get(schoolState, "accounts.purchase.displayName")}.
					</div>
				);
			} else if (OpsSchool.isPurchaseAuditor(schoolState, userID)) {
				paEl = (
					<div className={styles.pa}>
						Current Auditor for{" "}
						{_.get(schoolState, "accounts.purchase.displayName")}.
					</div>
				);
			}
			const canEdit =
				_.includes(["purchaseAdmin", "schoolAdmin", "partialAdmin"], role) &&
				OpsSchool.isPurchaseActive(schoolState);
			const addClassEl =
				canEdit && !isAcademy ? (
					<div
						className={styles.button}
						onClick={() => this.props.showModal("addInfo", "teacherAddClass")}
					>
						Add to class
					</div>
				) : null;
			if (isActive) {
				const infoEl =
					hasPassword || hasPassword === undefined ? null : (
						<div className={styles.setupInfo}>
							(Set up incomplete
							<InfoIcon
								text={CopyTable.getAccountConfirmCopy()}
								textClass={styles.infoText}
								className={styles.infoButton}
							/>
							)
						</div>
					);
				return (
					<div className={styles.teacher}>
						<div className={styles.info}>
							<div className={styles.email}>
								<div className={styles.emailInner}>
									<span className={styles.label}>Email:</span>
									{isAcademy ? (
										<div className={styles.labelText}>{teacher.email}</div>
									) : (
										<Editable
											className={styles.labelText}
											text={teacher.newEmail || teacher.email}
											onClick={() =>
												showModal("updateInfo", {type: "email", userID})
											}
										/>
									)}
									{infoEl}
								</div>
								{teacher.newEmail &&
								teacher.newEmail !== teacher.email &&
								!isAcademy ? (
									<div className={styles.newEmail}>
										{CopyTable.getNewEmailCopy(teacher.newEmail, teacher.email)}
									</div>
								) : null}
							</div>
							{isAcademy ? null : (
								<div className={prClass} onClick={this.onResetEmail}>
									{prText}
								</div>
							)}
						</div>
						{paEl}
						{this.getSchoolTable(schoolState, userID, isActive, role)}
						{this.getClassTable(schoolState, userID, isActive, role)}
						{this.getAuditTable(schoolState, userID, isActive, role)}
						{addClassEl}
					</div>
				);
			} else {
				return (
					<div className={styles.teacher}>
						<div className={styles.info}>
							<div className={styles.email}>
								<span className={styles.label}>Email:</span>
								<span className={styles.labelText}>{teacher.email}</span>
							</div>
						</div>
						{this.getSchoolTable(schoolState, userID, isActive, role)}
						{this.getClassTable(schoolState, userID, isActive, role)}
						{this.getAuditTable(schoolState, userID, isActive, role)}
						{addClassEl}
					</div>
				);
			}
		},

		renderStudent: function(student, role, isAcademy) {
			const {userID, schoolState, showModal} = this.props;
			const isActive = OpsSchool.isStudentActive(schoolState, userID);
			const purchase = _.get(schoolState, "accounts.purchase", {});
			const isPurchaseActive = purchase.active;
			const hasLoginPerms =
				_.includes(["purchaseAdmin", "schoolAdmin"], role) && isPurchaseActive;
			const hasPerms = _.includes(
				["purchaseAdmin", "schoolAdmin", "teacher"],
				role
			);

			const usernameEl = purchase.domain ? (
				<div className={styles.username}>
					<div className={styles.label}>School Login</div>
					{isActive && hasLoginPerms && !isAcademy ? (
						<Editable
							className={styles.editableText}
							text={student.schoolLogin}
							onClick={() =>
								showModal("updateInfo", {type: "schoolLogin", userID})
							}
						/>
					) : (
						student.schoolLogin
					)}
				</div>
			) : (
				<div className={styles.username}>
					<span className={styles.label}>Username:</span>
					{student.username || student.schoolLogin}
				</div>
			);
			const studentIDEl = (
				<div className={styles.studentID}>
					<span className={styles.label}>Student ID:</span>
					{student.intStudentID || "(none)"}
				</div>
			);
			return (
				<div className={styles.student}>
					<div className={styles.studentInfo}>
						{usernameEl}
						{studentIDEl}
						<div className={styles.displayName}>
							<div className={styles.label}>Display Name</div>
							{isActive && hasPerms && !isAcademy ? (
								<Editable
									className={styles.editableText}
									text={student.displayName}
									onClick={() =>
										showModal("updateInfo", {type: "displayName", userID})
									}
								/>
							) : (
								student.displayName
							)}
						</div>
						<div className={styles.password}>
							<div className={styles.label}>Password</div>
							{isActive && hasPerms && !isAcademy ? (
								<Editable
									className={styles.editableText}
									text="********"
									onClick={() =>
										showModal("updateInfo", {type: "password", userID})
									}
								/>
							) : (
								"********"
							)}
						</div>
					</div>
					{this.getClassTable(schoolState, userID, isActive)}
					{hasLoginPerms && !isAcademy ? (
						<div
							className={styles.button}
							onClick={() => showModal("addInfo", "transfer")}
						>
							Transfer
						</div>
					) : null}
				</div>
			);
		},

		render: function() {
			const {userID, schoolState, user} = this.props;
			const isStaff = OpsSchool.isStaff(schoolState, userID);
			const isPurchaseAdmin = OpsSchool.isPurchaseAdmin(schoolState, userID);
			const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
			let content;
			let isClassActive;
			let studentClass;

			const targetUser = OpsSchool.getUser(schoolState, userID);
			const role = isStaff
				? OpsSchool.getBestRoleForStaff(schoolState, user.userID, userID)
				: OpsSchool.getBestRoleForStudent(schoolState, user.userID, userID);
			if (isStaff) {
				content = this.renderStaff(targetUser, role, isAcademy);
			} else {
				content = this.renderStudent(targetUser, role, isAcademy);
				studentClass = OpsSchool.getClassForStudent(schoolState, userID);
				isClassActive = OpsSchool.isClassActive(schoolState, studentClass.id);
			}
			const purchaseActive = OpsSchool.isPurchaseActive(schoolState);

			const userType = isStaff ? "user" : "student";
			let activeText;
			if (isStaff) {
				activeText = OpsSchool.isStaffResolvedActive(schoolState, userID)
					? "deactivate"
					: "activate";
			} else {
				activeText = OpsSchool.isStudentActive(schoolState, userID)
					? "deactivate"
					: "activate";
			}

			let deactivateEl;
			let hoverMessage;
			let hideDeactivate;

			if (
				isPurchaseAdmin &&
				OpsSchool.getPurchaseAdmins(schoolState).length === 1
			) {
				hoverMessage = `Cannot deactivate the only active system administrator.`;
			} else if (!isClassActive && !isStaff) {
				hideDeactivate = true;
			}
			const hasPerms = isStaff
				? !!role && role !== "self" && role !== "teacher"
				: !!role && role !== "teacher";
			if (!purchaseActive || user.userID === userID || !hasPerms || isAcademy) {
				// Don't show this button
				// - cannot deactivate yourself.
				// - must have permission
				hideDeactivate = true;
			}
			if (hideDeactivate) {
				// Don't show button
			} else if (hoverMessage) {
				deactivateEl = (
					<HoverText
						className={styles.hoverOuter}
						text={hoverMessage}
						size="medium"
						canWrap={true}
						direction="T"
					>
						<div className={styles.inactive}>{`${activeText} ${userType}`}</div>
					</HoverText>
				);
			} else {
				deactivateEl = (
					<div
						className={styles[activeText]}
						onClick={() =>
							this.props.showModal("confirmInfo", {
								type: activeText,
								userID,
								isStaff,
								active: !targetUser.active,
							})
						}
					>
						{`${activeText} ${userType}`}
					</div>
				);
			}

			return (
				<div className={styles.main}>
					{content}
					{deactivateEl}
				</div>
			);
		},
	})
);
